import {
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    HostBinding,
    HostListener,
    Input,
    OnChanges,
    Output, SimpleChanges, ViewChild
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SelectOptionModel} from '../../../models/select-option-model';

@Component({
    selector: 'app-input-flat-select-list',
    templateUrl: './input-flat-select-list.component.html',
    styleUrl: './input-flat-select-list.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputFlatSelectListComponent),
            multi: true,
        },
    ],
})
export class InputFlatSelectListComponent implements ControlValueAccessor, OnChanges {

    @Input() public label: string;
    @Input() public name: string;
    @Input() public options: SelectOptionModel<any>[] = [];
    @Input() public required: boolean | string;

    @HostBinding('class.active') isActive: boolean;

    @Input() public placeholderHtml: string = 'Select an option';

    @Input('disabled') isDisabledInput: boolean | number | '';
    @HostBinding('class.disabled') isDisabled: boolean;


    @Output() public blur: EventEmitter<any> = new EventEmitter<any>();
    @Output() public focus: EventEmitter<any> = new EventEmitter<any>();

    @Input() compareByFn: (item1: any, item2: any) => boolean = this.compareByDefaultFn;
    @Input() button_faIcon!: string;
    @Input() buttonOptionDisabled_faIcon!: string;


    @ViewChild('border') borderElement!: ElementRef;

    // @HostBinding('style')  hostStyles: { [key: string]: string } = {
    //     '--button-color': '#007bff',
    //     '--border-color': '#00ff00',
    //     '--text-color': '#ff5733',
    // }

    public propagateChange: (_: any) => void = (_: any) => {
    };
    public onTouched: () => void = () => {
    };
    public value: any[];
    public valueAsOptions: SelectOptionModel<any>[] = [];


    constructor(private elementRef: ElementRef) {
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (this.isDisabledInput !== '') {
            this.isDisabled = !!this.isDisabledInput;
        } else {
            this.isDisabled = true;
        }

        if (this.options) {
            this.valueAsOptions = this.getValueAsOptions(this.value);
        }
    }

    get isRequired(): boolean {
        return this.required === '' || this.required === true;
    }

    getLabel() {
        return this.label + (this.isRequired ? '*' : '');
    }

    writeValue(value: any): void {
        this.value = value;
        this.valueAsOptions = this.getValueAsOptions(value);
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    compareByDefaultFn(item1: any, item2: any): boolean {
        return item1 === item2;
    }


    onFocus(): void {
        if (!this.isActive) {
            this.isActive = true; // Activate focus state only once
            this.focus.emit(); // Emit focus event
        }
    }


    onBlur(): void {
        setTimeout(() => {
            const activeElement = document.activeElement;


            if (this.borderElement && !this.borderElement.nativeElement.contains(activeElement) && this.borderElement.nativeElement !== activeElement) {
                this.isActive = false; // Deactivate focus state
                this.onTouched(); // Mark as touched for forms
                this.blur.emit(); // Emit blur event
            }
        }, 0);
    }

    getValueAsOptions(value: any): SelectOptionModel<any>[] {
        // returns options for values in the same order

        if (!value) {
            return [];
        } else if (!Array.isArray(value)) {
            console.warn('Input value is not an array ');
            return [];
        }

        let result: SelectOptionModel<any>[] = [];
        value.forEach((val: any) => {
            let option = this.options?.find(option => this.compareByFn(option.value, val));
            if (option) {
                result.push(option);
            } else {
                console.warn('Option with value', val , 'not found in options');
            }

        });
        return result;

    }

    onRemoveItemBtnClick(index: number): void {
        // Remove item from valueAsOptions by index
        if (this.valueAsOptions && this.valueAsOptions.length > index) {
            this.valueAsOptions.splice(index, 1);
            this.value = this.valueAsOptions.map(option => option.value);
            this.propagateChange(this.value);

            // Determine the next focusable element
            const options = this.borderElement.nativeElement.querySelectorAll('.option-container');
            if (options.length > 0) {
                console.log('onRemoveItemBtnClick', ((options[index + 1] as HTMLElement)?.querySelector('.btn') as HTMLElement));

                if (index < options.length) {
                    // Focus the next element if it exists
                    ((options[index + 1] as HTMLElement)?.querySelector('.btn') as HTMLElement)?.focus();
                } else {
                    // Otherwise, focus the previous element
                    ((options[index - 1] as HTMLElement).querySelector('.btn') as HTMLElement)?.focus();
                }
            } else {
                // If no options are left, focus the border element
                (this.borderElement.nativeElement as HTMLElement).focus();
            }
        }
    }

    trackByFn(index: number, item: any): any {
        return item?.value || index;
    }

    getFaIconClass(option: SelectOptionModel<any>) {
        return  (option.isDisabled && this.buttonOptionDisabled_faIcon) ? this.buttonOptionDisabled_faIcon : this.button_faIcon;
    }
}
